import { styled } from '@mui/material/styles';
import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';
import { MenuItem } from '@mui/material';

export const StyledAutoComplete = styled('div')`
  width: 100%;
  & .MuiOutlinedInput-root {
    height: ${({ customStyle }) => customStyle?.height || '40px'};
    border-radius: ${({ customStyle }) => customStyle?.borderRadius || '8px'};
    padding: 8px 12px;
    background: ${COLOR.white};
    border-color: ${({ customStyle }) =>
      customStyle?.borderColor || COLOR.borderButton};
    // Border color
    & input {
      padding: 0 !important;
    }
    & .MuiAutocomplete-endAdornment {
      right: 14px;
    }
  }
  & .MuiAutocomplete-input {
    font-weight: 400;
    font-size: 14px;
    vertical-align: middle;
    color: ${COLOR.darkGray};
  }
  .input-error {
    color: ${COLOR.functionalRed.default};
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.4px;
  }
`;

export const StyledMenuItem = styled(MenuItem)`
  padding: 10px 20px;
  cursor: pointer;
  color: ${(props) => (props.active ? COLOR.darkBlue : COLOR.text)};
  background-color: ${(props) => props.active && COLOR.secondary[80]};
  width: 100%;
  &:hover {
    color: ${(props) => (props.active ? COLOR.darkBlue : COLOR.text)};
    background-color: ${(props) =>
      props.active ? COLOR.secondary[80] : TRANSPARENT_COLOR.dark};
  }

  .text {
    font-weight: ${(props) => (props.active ? '500' : '400')};
  }
`;
